import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/media/mkg-website/branches/Machinebouw_product.webp");
;
import(/* webpackMode: "eager" */ "/app/public/media/mkg-website/branches/Oppervlaktebehandeling_product.webp");
;
import(/* webpackMode: "eager" */ "/app/public/media/mkg-website/branches/part_0.webp");
;
import(/* webpackMode: "eager" */ "/app/public/media/mkg-website/branches/part_2.webp");
;
import(/* webpackMode: "eager" */ "/app/public/media/mkg-website/branches/plaatwerk_product.webp");
;
import(/* webpackMode: "eager", webpackExports: ["RightMouseClickMenu"] */ "/app/src/components/RightMouseClickMenu/RightMouseClickMenu.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/partials/MkgEu/BranchesNavMenu/BranchesNavMenu.module.scss");
